export default __webpack_public_path__ + "static/media/PLDT-new.987b6579.png";